<div data-simplebar data-simplebar-direction="rtl" style="overflow-x: auto">
  <div style="display: flex; padding: 16px;">
    <div *ngFor="let artist of artists" class="artist-list-item" >
      <a [routerLink]="'/releases/artists/' + artist.id" (click)="clear()">
        <div class="artist-thumb" [style.background-image]="'url(' + musicDBapiSrc + '/coverArt/300/' + artist.id  + '/artist), url(/assets/no-photo.svg)'" ></div>
        <div>{{artist.name}}</div>
      </a>
    </div>
  </div>
</div>